module.exports = __webpack_public_path__ + "img/em-breve.98d4f296.jpg";